import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Select, Form, Button, Input, Upload, message, Icon, Typography, Card, Breadcrumb, DatePicker, Divider, Table, Calendar } from 'antd';
import { getStaticProRealInfo, getStaticReaInfoByMonth, getStaticRealListByMonth, getStaticReaList, getStaticReaInfo, ExpensesBroken, ExpensesRound, getExpenditure } from '@/api/api';
import moment from 'moment';
import echarts from 'echarts';
import utils from '@/api/util';
import { reqByGet } from '@/api/api'
import './statistical.css';
import servers from '@/api/server'

const Option = Select.Option;
const { Text, Title } = Typography;
let cost_cavans;


class Statistic_consume extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            dataList: [],//顶级数据数组
            typeId: 0,
            timeType: 1,
            id: null,
            projectName: '',
            reaList: [],
            reaIds: [],
            dataSource: [],
            table_loading: false,
            contextPage: 1,
            contextRows: 5,
            costYear: '',
            pagination: {
                pageSize: 5,
                hideOnSinglePage: true,
            },
            costMothRange: [],
            // timeType: 3,
            storeRangeValue: [],
            storeRangeFormat: 'YYYY-mm',
            storeRangeMode: ['month', 'month'],
            storeRangeValue1: null,
            storeRangeValue2: null,
            storeInfo: {},
            costEcharts_flag: true,
            storeRangeOpen: false
        };
        this.getReaList = this.getReaList.bind(this);
        this.realRealCostCanvas = this.realRealCostCanvas.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
    }

    componentDidMount() {
        cost_cavans = echarts.init(document.getElementById('realCost'));
        cost_cavans.showLoading();
        this.getReaList()
        getExpenditure(res => {
            console.log(res)
        }, err => {
            console.log(err)
            this.setState({
                dataList: err.dataList
            })
        })
        reqByGet(servers.ExpensesRound2, { typeId: 0 }, res => {
            console.log("67", res)
            if (res.reaName && res.reaName.length == 0) {
                this.setState({
                    costEcharts_flag: false
                })
            }
            this.realRealCostCanvas(res)
        }, (err) => {
            console.log('68', err)
        })
        //圆饼图
        // ExpensesRound({ typeId: 0 }, res => {
        //     console.log(res)
        //     this.realRealCostCanvas(res)
        // })
    }

    //修改state
    onStateChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    }

    // 耗材list
    getReaList() {
        const that = this;
        getStaticReaList({}, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                reaList: res.reaList
            });
        }, err => {
            console.log(err)
        })
    }


    // 获取耗材成本绘制
    realRealCostCanvas(values) {
        const that = this;
        cost_cavans.clear();
        console.log(values)
        let datas = [];
        values.reaName.map((x, index) => {
            let ret = {};
            ret.value = (values.per[index] * 100).toFixed(1);
            ret.name = x;
            datas.push(ret)
        });
        cost_cavans.setOption({
            title: {
                text: '经费使用占比',
                x: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    return params.seriesName + '<br/>' + params.name + ':' + params.value + '%(￥' + values.money[params.dataIndex] + ')'
                }
            },
            legend: {
                // orient: 'vertical',
                right: 'center',
                bottom: 0,
                data: values.reaName,
                formatter: function (name) {
                    if (name.length > 16) {
                        return name.substr(0, 15) + '..'
                    }
                    return name;
                }
            },
            series: [
                {
                    name: '经费使用占比',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '45%'],
                    data: datas,
                    label: {
                        formatter: (params) => {
                            if (params.name.length > 16) {
                                return params.name.substr(0, 15) + '..'
                            };
                            return params.name;
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }, true);
        cost_cavans.on('rendered', function () {
            cost_cavans.hideLoading()
        });
    }


    //原图选择
    handleChage = (value) => {
        console.log(value)
        let params = { typeId: 1, Id: value }
        ExpensesRound(params, res => {
            this.realRealCostCanvas(res)
        })
    }
    render() {
        const that = this;
        const { dataList, costEcharts_flag } = this.state;
        return (
            <div className="statistic">
                <Card
                    title={
                        <div className="pr">
                            <Text strong className="mr5" style={{ fontSize: '15px' }}><i className="iconfont icon-huabanfuben1 c_8bff mr5 vt"></i>经费使用占比</Text>
                            <Select
                                onChange={this.handleChage}
                                placeholder="请选择"
                                className="inlineBlock mr10"
                                style={{ minWidth: '124px', float: 'right' }}
                            >
                                {dataList.map(x => {
                                    return (
                                        <Option value={x.id.toString()} key={x.id} title={x.projectName}>
                                            {x.projectName}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </div>
                    }
                    className="statistic_panel"
                >
                    <div className="pr">
                        {!costEcharts_flag &&
                            <img src={servers.defaultNoContentPath} alt="暂无内容" className="noContent" />
                        }
                        <div className="statistic_pro_tabPane1" id="realCost"></div>
                    </div>
                </Card >
            </div>
        )
    }
}

export default Statistic_consume;
